module.exports = __webpack_public_path__ + "static/media/SP_C_Jacquard_Accademia_DK Chocolate_LT Grey.c548994e.png";